import { AxiosResponse } from 'axios';
import { OPS_SERVICE_API_URL } from '../../../../config';
import opsAxios from '../../../../utils/axios/ops.axios';

const tryToFetchAiModels = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${OPS_SERVICE_API_URL}/ai-models/all?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${OPS_SERVICE_API_URL}/ai-models/all?page=${pageNumber}&size=${pageSize}`;
    return opsAxios.put<any>(url, data);
};

const tryToFetchAllAiModels = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${OPS_SERVICE_API_URL}/ai-models/all`
    return opsAxios.put(url, data?.data);
};

const tryToFetchSingleAiModel = (id: string): Promise<AxiosResponse<any>> => {
    return opsAxios.get(`${OPS_SERVICE_API_URL}/ai-models/${id}`);
};

const tryToCreateAiModel = (data: any): Promise<AxiosResponse<any>> => {
    return opsAxios.post(`${OPS_SERVICE_API_URL}/ai-models`, data);
};

const tryToEditAiModel = (data: any): Promise<AxiosResponse<any>> => {
    return opsAxios.put(`${OPS_SERVICE_API_URL}/ai-models/${data?.id}/edit`, data?.data);
};

const tryToDeleteAiModel = (data: any): Promise<AxiosResponse<any>> => {
    return opsAxios.put(`${OPS_SERVICE_API_URL}/ai-models/delete-ai-model/${data?.id}`);
};

export const AiModelsService = {
    tryToFetchAiModels,
    tryToFetchAllAiModels,
    tryToFetchSingleAiModel,
    tryToEditAiModel,
    tryToCreateAiModel,
    tryToDeleteAiModel
};